module.exports = __webpack_public_path__ + "img/scale.1c46df9b.png";